import { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { getMessages } from '../../common/utils/get-messages';
import { getMessagesForLocation } from '../../common/utils/get-messages-for-location';
import type { NavErrorBoundaryProps } from '../../ui/types';

type UseBoundaryMessagesArgs = Pick<
	NavErrorBoundaryProps,
	'errorMessages' | 'errorMessageValues' | 'location'
> & { location: string };

/**
 * Resolves the failure header/description MessageDescriptors (and any
 * interpolation values) for the boundary
 */
export function useBoundaryMessages({
	errorMessages,
	errorMessageValues,
	location,
}: UseBoundaryMessagesArgs): Record<string, any> {
	return useMemo(() => {
		return fg('navx-4866-migrate-messages-from-nav-error-boundary')
			? getMessages({ errorMessages, errorMessageValues, location })
			: getMessagesForLocation(location);
	}, [location, errorMessages, errorMessageValues]);
}
